module.exports = __webpack_public_path__ + "static/media/tempCharlieCard.5e906b6d.svg";